import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#9DA4B4",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 2c.473 0 .857.384.857.857v4.286h4.286a.857.857 0 0 1 0 1.714H8.857v4.286a.857.857 0 1 1-1.714 0V8.857H2.857a.857.857 0 0 1 0-1.714h4.286V2.857C7.143 2.384 7.527 2 8 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }